import React, { useEffect, useState } from 'react'
import moment from 'moment'

import CalendarHeader from '../../../components/calendar/month/CalendarHeader'
import CalendarWeekDays from '../../../components/calendar/month/CalendarWeekDays'
import CalendarDateCells from '../../../components/calendar/month/CalendarDateCells'

import '../../../styles/scss/components/calendar/calendar.scss'

const CalendarContainer = () => {
  const [currentDate, setCurrentDate] = useState(new Date())
  const [selectedDate, setSelectedDate] = useState('')

  useEffect(() => {
    closeEventsPopover()
  }, [])

  const closeEventsPopover = () => {
    setSelectedDate('')
  }

  const openEventsPopover = (day) => {
    setSelectedDate(day)
  }

  const handleNextMonth = () => {
    setCurrentDate(moment(currentDate).add(1, 'months'))
  }

  const handlePrevMonth = () => {
    setCurrentDate(moment(currentDate).subtract(1, 'months'))
  }

  return (
    <div className="decoupled-events__calendar">
      <div className="u-calendar">
        <CalendarHeader
          currentDate={currentDate}
          handleNextMonth={handleNextMonth}
          handlePrevMonth={handlePrevMonth}
        />
        <CalendarWeekDays currentDate={currentDate} />
        <CalendarDateCells
          currentDate={currentDate}
          openEventsPopover={openEventsPopover}
          closeEventsPopover={closeEventsPopover}
          selectedDate={selectedDate}
        />
      </div>
    </div>
  )
}

export default CalendarContainer
